import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=4631b1fc&"
import script from "./SearchInput.vue?vue&type=script&lang=js&"
export * from "./SearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports